import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material';

export default function RadioGroupField(props) {
  return (
    <FormControl required={props.required} error={props.error} disabled={props.disabled}>
      {props.label && <FormLabel component="legend">{props.label}</FormLabel>}
      <RadioGroup row name={props.name} value={props.value} onChange={props.onChange}>
        {props.options.map((opt) => (
          <FormControlLabel
            key={opt}
            value={opt}
            control={<Radio id={`field-${props.name}-${opt}`} />}
            label={opt}
          />
        ))}
      </RadioGroup>
      {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  );
}
